// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__8pJwu","dropdown":"style_dropdown___g4qt"};